import { cx } from './utils.js'

// InfoCard (Wave 28, migrated off Tailwind in Wave 47q) — primitive
// for the dashboard autonomy strip, engagement insights cards, and
// any future "labeled card with custom body" surface.
//
// Premium-SaaS refinement (2026-06-10): supports new card design language
// with crisp borders, generous padding, and refined tone mapping.
//
// Variants:
//   - tone: neutral | success | error | warning | planning | intel
//   - onClick: when provided, renders as <button> with hover affordance
//   - fullSpan: spans the full width of a CSS grid (incidents banner pattern)
//   - icon: optional small leading glyph (Heroicon node), pairs with label
//
// All styling is via .studio-info-card-* rules in studio.css.

export function InfoCard({
  label,
  icon,
  tone = 'neutral',
  onClick,
  fullSpan = false,
  className,
  children,
  title,
}) {
  const Component = onClick ? 'button' : 'div'
  return (
    <Component
      type={onClick ? 'button' : undefined}
      onClick={onClick}
      title={title}
      className={cx(
        'studio-info-card',
        tone !== 'neutral' ? `tone-${tone}` : '',
        onClick ? 'clickable' : '',
        fullSpan ? 'full-span' : '',
        className
      )}
    >
      {label || icon ? (
        <div className="studio-info-card-label">
          {icon ? (
            <span className="studio-info-card-label-icon" aria-hidden="true">
              {icon}
            </span>
          ) : null}
          {label}
        </div>
      ) : null}
      <div className="studio-info-card-content">{children}</div>
    </Component>
  )
}
